<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="分成方式"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="mapForm">
        <el-form-item label="流水分成比例" prop="ratio">
          <el-input v-model="form.ratio" placeholder="分成比例"></el-input>
        </el-form-item>

        <el-form-item label="人次使用费">
          <el-input
            v-model="form.user_flow_price"
            placeholder="单次使用金额，如0.1"
          ></el-input
          >元/次
        </el-form-item>

        <el-form-item label="返利方式">
          <el-radio-group v-model="form.rebate_type">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">金额</el-radio>
            <el-radio :label="2">比例</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="返利金额" v-if="form.rebate_type == 1">
          <el-input
            v-model="form.rebate_cash"
            placeholder="如2000"
          ></el-input>
        </el-form-item>

        <el-form-item label="返利比例" v-if="form.rebate_type == 2">
          <el-input
            v-model="form.rebate_ratio"
            placeholder="如0.5"
          ></el-input>
        </el-form-item>

        <el-form-item label="加速阈值">
          <el-input v-model="form.threshold" placeholder="加速阈值"></el-input
          >元
          <p>
            加速说明：若设置加速阈值，设备分成总额小于加速阈值时：实际分成比例 =
            分成比例 + 加速阈值
          </p>
        </el-form-item>
        <el-form-item label="加速比例">
          <el-input v-model="form.hi_ratio" placeholder="加速比例"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { profit_rules } from "../rule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      rules: profit_rules,
      addServiceDialog: false,
      admin_id: "",
      device: {},
    };
  },

  mounted() {
    this.admin_id = this.$route.query.id;
  },
  methods: {
    open(row) {
      this.device = row;
      this.addServiceDialog = true;
      this.getInfo();
    },

    getInfo() {
      let url = "/user/devicePlanProfit/queryListPage";

      this.$get(url, {
        device_sn: this.device.device_sn,
      }).then((res) => {
        if (res.data.data.length > 0) {
          let info = res.data.data[0];
          this.form = this.temp = Object.assign({}, info);
          this.temp = info;
        } else {
          this.form = {};
          this.temp = {};
        }
      });
    },
    updateForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/devicePlanProfit/insert";
      this.form.device_sn = this.device.device_sn;
      this.form.plan_id = this.device.plan_id;
      this.form.admin_id = this.device.invest_id;

      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
    
      if (Object.keys(data).length == 0) {
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        return;
      }
      data.id = this.form.id;
      let url = "/user/devicePlanProfit/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>